import { Link } from 'react-router';

import { TextPage } from '../components/TextPage';

import styles from './ContactPage.module.css';

// Words approved by Warren for #175. Every question goes to support@kudu.com,
// and the co-founders' addresses are the ones on /about.
export function ContactPage() {
  return (
    <TextPage title="Contact">
      <p>Reach out and we will route your message to the right team.</p>
      <section>
        <h2>Demos, mapping calls, pilots and the Kai Coach pilot report</h2>
        <p className={styles.addresses}>
          <a href="mailto:support@kudu.com">support@kudu.com</a>
        </p>
      </section>
      <section>
        <h2>Help with a course or your account</h2>
        <p className={styles.sentence}>
          <Link to="/help">Help</Link>, or{' '}
          <a href="mailto:support@kudu.com">support@kudu.com</a>
        </p>
      </section>
      <section>
        <h2>Privacy, accessibility or security</h2>
        <p className={styles.addresses}>
          <a href="mailto:support@kudu.com">support@kudu.com</a>
        </p>
      </section>
      <section>
        <h2>Talk to a co-founder</h2>
        <p className={styles.addresses}>
          <a href="mailto:warren@kudu.com">warren@kudu.com</a>,{' '}
          <a href="mailto:kusenko@kudu.com">kusenko@kudu.com</a>
        </p>
      </section>
    </TextPage>
  );
}
